// extracted by mini-css-extract-plugin
module.exports = {"container":"_3xPyr","logo":"_3H1Ms","clinicDataContainer":"nRmf4","clinicName":"dKOVh","phoneDataContainer":"_2hvfJ","phoneLabel":"_9lt7q","phoneValue":"_2ZdQ3","button":"_35TdV"};